import { createTheme } from '@mui/material/styles';

export const avansTheme = createTheme({
  palette: {
    primary: {
      main: '#1B6B5A',
      light: '#2A8A74',
      dark: '#0F4A3D',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F5A623',
      light: '#F7B84E',
      dark: '#D4891A',
    },
    background: {
      default: '#F7F9F8',
      paper: '#ffffff',
    },
    text: {
      primary: '#1A2B25',
      secondary: '#3D4948',
    },
    success: {
      main: '#1B6B5A',
    },
    grey: {
      100: '#F4F6F5',
      200: '#E8EDEB',
      300: '#D1DDD8',
      400: '#A8BDB5',
      500: '#7A9990',
    },
  },
  typography: {
    fontFamily: 'Jost',
    h1: {
      fontFamily: 'Jost',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Jost',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Jost',
      fontWeight: 600,
    },
    h4: {
      fontFamily: 'Jost',
      fontWeight: 700,
    },
    h5: {
      fontFamily: 'Jost',
      fontWeight: 600,
    },
    h6: {
      fontFamily: 'Jost',
      fontWeight: 600,
    },
    body1: {
      fontFamily: 'Jost',
      fontSize: '0.9375rem',
    },
    body2: {
      fontFamily: 'Jost',
      fontSize: '0.875rem',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 10,
          padding: '12px 28px',
          fontSize: '1rem',
          fontFamily: 'Jost',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1B6B5A 0%, #2A8A74 100%)',
          boxShadow: '0 4px 16px rgba(27, 107, 90, 0.25)',
          '&:hover': {
            background: 'linear-gradient(135deg, #0F4A3D 0%, #1B6B5A 100%)',
            boxShadow: '0 6px 20px rgba(27, 107, 90, 0.35)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#ffffff',
            fontFamily: 'Jost',
            '& fieldset': {
              borderColor: '#D1DDD8',
            },
            '&:hover fieldset': {
              borderColor: '#1B6B5A',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1B6B5A',
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 16px rgba(27, 107, 90, 0.08)',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          borderRadius: 10,
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#ffffff',
          },
        },
      },
    },
  },
});